/**
 * Adapptio Core library.
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export const TEMP_FILE = {
	/** Temporary file default TTL in milliseconds */
	EXPIRES_IN: 30000,
	/** Check temporary files TTL every milliseconds */
	CHECK_EVERY: 60000
};
